export default "__VITE_ASSET__aeae723d__"